import React from "react"
import Checkbox from "@infotech/uikit-checkbox"
import styles from "./styles.css"

/* Uikit Input wrapper to works with reduxForm Field */
export default ({ input, meta: { valid }, ...rest }) => (
  <div className={styles[`checkbox-wrapper`]}>
    <Checkbox
      {...input}
      {...rest}
      invalid={!valid}
      checked={!!input.value}
      onCheckedChange={input.onChange}
    />
  </div>
)
